<template>
  <div>
      <div v-if="audioEnabled === false" class="audio-overlay">
          <button @click="playNotificationSound" class="enable-audio-btn">Habilitar Audio</button>
      </div>
      
      <div v-if="consoleMessages!=''">
        {{ consoleMessages }}
      </div>
      <SalesDashboard />
      <Celebration :visible="showCelebration" :celebration-data="celebrationData" />
      <div class="websocket-status">
          <v-chip :color="isConnected ? 'green' : 'red'" x-small dark>
              WebSocket 
          </v-chip>
          <v-chip :color="audioEnabled ? 'green' : 'red'" x-small dark>
              Audio
          </v-chip>
          <v-btn x-small @click="playNotificationSound" :disabled="isConnected" class="ml-2">
              Reconectar
          </v-btn>
        </div>
  </div>
</template>
<script>

import SalesDashboard from '@/components/sales/SalesDashboard.vue'
import Celebration from '@/components/alerts/Celebration.vue'
import fanfareSound from '@/assets/fanfare.mp3'
import crowdCheering from '@/assets/crowd-cheering.mp3'
import vuvuzela from '@/assets/vuvuzela.mp3'
import redAlertSiren from '@/assets/red-alert-siren.mp3'
import applause from '@/assets/applause.mp3'
import { SOCKET_URL } from '@/main.js'

export default {
  name: 'Congratulations',
  components: {
    SalesDashboard,
    Celebration
  },
  data() {
    return {
      message: null,
      socket: null,
      isConnected: false,
      audioEnabled: false,
      showCelebration: false,
      celebrationData: {
        mensaje: '',
        vendedor: '',
        monto: ''
      },
      soundsFanFareArray: [redAlertSiren],
      soundsCheeringArray: [crowdCheering,applause],
      consoleMessages: '',
      audio: new Audio(redAlertSiren)
    };
  },
  mounted() {
    //this.connectWebSocket();
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.close();
    }
  },
  
  methods: {
    enableAudio() {
      try {
        this.playNotificationSound().then(() => {
          this.audioEnabled = true;
          console.log('Audio habilitado');
        }).catch(error => {
          console.log('Error habilitando audio:', error);
          this.consoleMessages += 'Error habilitando audio: ' + error + '\n';
        });
      } catch (error) {
        console.log('Error creando audio para habilitar:', error);
        this.consoleMessages += 'Error creando audio para habilitar: ' + error + '\n';
      }
      this.connectWebSocket();
    },
    playNotificationSound() {
      this.audioEnabled = true; // Asumir que el audio está habilitado al intentar reproducir
      return new Promise((resolve, reject) => {
        if (!this.audioEnabled) {
          console.log('Audio no habilitado, no se puede reproducir sonido');
          resolve();
          return;
        }
        try {
          this.audio.play().then(() => {
            console.log('Audio de notificación reproducido con éxito');
            resolve();
          }).catch(error => {
            console.log('Error reproduciendo sonido de notificación:', error);
            this.consoleMessages += 'Error reproduciendo sonido de notificación: ' + error + '\n';
          });
          if(!this.isConnected){
            this.connectWebSocket();
          }
        } catch (error) {
          console.log('Error creando audio:', error);
          reject(error);
        }
      });
      

    },
    async celebrateSeller(mensaje, vendedor, monto) {
      this.celebrationData = { mensaje, vendedor, monto };
      try {
        await this.playNotificationSound().then(() => {
          console.log('Sonido de notificación reproducido, iniciando celebración');

          this.showCelebration = true;
        });
        console.log('Sonido de notificación terminado');
        setTimeout(() => {
          this.showCelebration = false;
        }, 10000);
        this.$root.$emit('update-dashboard');
      } catch (error) {
        console.log('Error reproduciendo sonido:', error);
        this.consoleMessages += 'Error reproduciendo sonido: ' + error + '\n';
      }
    },
    randomSelectFanFareSound() {
      const index = Math.floor(Math.random() * this.soundsFanFareArray.length);
      return this.soundsFanFareArray[index];
    },
    randomSelectCheeringSound() {
      const index = Math.floor(Math.random() * this.soundsCheeringArray.length);
      return this.soundsCheeringArray[index];
    },
    connectWebSocket() {
      // Cambia la URL por la de tu servidor y ruta websocket
      this.socket = new WebSocket(SOCKET_URL);
      this.isConnected = this.socket.readyState === WebSocket.OPEN;
      this.socket.onopen = () => {
        this.isConnected = true;
        console.log('WebSocket conectado');
      };
      try{

        this.socket.onmessage = (event) => {
          const data = JSON.parse(event.data);
          console.log('Datos recibidos del WebSocket:', data);
          
          this.celebrateSeller(data.message.mensaje, data.message.vendedor, data.message.monto);
          console.log('Mensaje recibido:', data);
    
  
        };
      } catch (error) {
        console.log('Error procesando mensaje del WebSocket:', error);
        this.consoleMessages += 'Error procesando mensaje del WebSocket: ' + error + '\n';
      }
      this.socket.onclose = () => {
        this.isConnected = false;
        console.log('WebSocket cerrado');
      };
      this.socket.onerror = () => {
        this.isConnected = false;
        console.log('WebSocket error');
      };
    },
    reconnect() {
      if (this.socket) {
        this.socket.close();
      }
      this.connectWebSocket();
    }
}
};
</script>

<style>
.audio-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.enable-audio-btn {
  padding: 20px 40px;
  font-size: 24px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.enable-audio-btn:hover {
  background-color: #0056b3;
}

.websocket-status {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  display: flex;
  align-items: center;
}
</style>